import React from 'react'
import { bool, func } from 'prop-types'
import { connect } from 'react-redux'

import { userType } from 'models/propTypes'

import { signupUser, loginUser } from 'models/user/actions'

import { getCurrentUser } from 'models/user/selectors'

import SignupForm from 'components/accountAccess/SignupForm'

const SignupFormContainer = ({ isLogin, signupWithEmail, loginWithEmail, user }) => (
    <SignupForm
        isLogin={isLogin}
        signupWithEmail={signupWithEmail}
        loginWithEmail={loginWithEmail}
        currentUser={user}
    />
)

SignupFormContainer.defaultProps = {
    isLogin: false,
}

SignupFormContainer.propTypes = {
    isLogin: bool,
    signupWithEmail: func.isRequired,
    loginWithEmail: func.isRequired,
    user: userType.isRequired,
}

const mapStateToProps = (state) => ({
    user: getCurrentUser(state),
})

const mapDispatchToProps = (dispatch) => ({
    signupWithEmail: (userData) => dispatch(signupUser(userData)),
    loginWithEmail: (userData) => dispatch(loginUser(userData)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignupFormContainer)
